import { SIDEBAR_MODES, SIDEBAR_SECTIONS } from "@/business-settings/constants";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { IPayout } from "@/payouts/payouts";
import { useGetPayouts } from "@/payouts/query";
import { ReferralPaymentsTable } from "./referral-payments-table";

interface ReferralPaymentsProps {
  businessId?: string;
}

export const ReferralPayments = ({ businessId }: ReferralPaymentsProps) => {
  const { data: payments = [], isLoading } = useGetPayouts(businessId);
  const {
    updateSidebar,
    state: { selectedItemId },
  } = useBusinessSettingsSidebar();

  const handleSelectPayment = (payment: IPayout) => {
    updateSidebar({
      section: SIDEBAR_SECTIONS.referralPayments,
      mode: SIDEBAR_MODES.view,
      selectedItemId: payment.id,
      isOpen: true,
    });
  };

  return (
    <ReferralPaymentsTable
      data={payments}
      isLoading={isLoading}
      onRowClick={handleSelectPayment}
      selectedReferralPaymentId={selectedItemId}
    />
  );
};
